export const LocalStorageService = {
    getItem<T>(key: string): T {
        const item = localStorage.getItem(key);
        return item ? JSON.parse(item) : null;
    },
    setItem<T>(key: string, value: T): void {
        localStorage.setItem(key, JSON.stringify(value));
    }
};
